var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"outer"},[_c('div',{staticClass:"pluginContent"},[_c('div',{staticClass:"panel inner"},[_c('PluginContainer',{attrs:{"plugin":{url:_vm.autoUrl, selected:true}}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }